import React, { useEffect, useState } from 'react';
import { Card, Tabs } from 'antd';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import ClassDepartmentSessionNo from './ClassDepartmentSessionNo';
import ClassDepartmentSessionYes from './ClassDepartmentSessionYes';
import { useStoreActions, useStoreState } from '../../../../store/hooks/easyPeasy';

    export default function ClassDepartmentSession(){
        const { TabPane } = Tabs;
        const setReport = useStoreActions((state) => state.student.setReport);

        return(
            <>
                <Card title="Class Department Session">
                    <Tabs defaultActiveKey="1" onChange={()=>setReport()}>
                        <TabPane tab="Current" key="1">
                            <ClassDepartmentSessionNo />
                        </TabPane>
                        <TabPane tab="Previous" key="2">
                            <ClassDepartmentSessionYes />
                        </TabPane>
                    </Tabs>
                </Card>
            </>
        )
    }